export default __webpack_public_path__ + "static/media/companyTypeBackground.444b984c.jpg";